export default __webpack_public_path__ + "static/media/WutowLogoIcon.bfa9a295.svg";